import { useState, useEffect } from "react"
import { BannerAd } from "src/tags/ads/BannerAd"
import { AdTargetingData } from "src/types/ads/AdTargetingData"

export const useFetchBanner = (
  bannerType: keyof typeof BannerAd,
  adTargetingData: AdTargetingData | null
): React.ReactNode | null => {
  const [banner, setBanner] = useState<React.ReactNode | null>(null)

  useEffect(() => {
    const fetchBanner = async () => {
      if (adTargetingData) {
        try {
          const fetchedBanner = await BannerAd[bannerType](adTargetingData)
          setBanner(fetchedBanner)
        } catch (error) {
          console.error(`Error fetching ${bannerType} banner:`, error)
        }
      }
    }

    fetchBanner()
  }, [bannerType, adTargetingData])

  return banner
}
